import axios from "axios";
import { create } from "apisauce";
import ApiConfigs from "../../Configs/Api";
import { request } from '~/Services/Api/axios-utils'

const customAxiosInstance = axios.create({
  baseURL: ApiConfigs.apiUrl,
  timeout: ApiConfigs.timeout,
  headers: {
    // Accept: `application/json;v=${ApiConfigs.version}`,
    Accept: `application/json`,
    "Content-Type": "application/json",
    // 'Content-Type': 'application/x-www-form-urlencoded',
  },
});
const Api = create({ axiosInstance: customAxiosInstance });

const CancelToken = axios.CancelToken;
const requestsSourceCancellation = CancelToken.source();
const endpoints = {
  // Authorization : Bearer 739|jSn9fHA0Y82vUJCPFMd6ZQp5rUTKnK2xZmaYvE7826342746
  pharmacies: {
    get: (data, headers) =>
      request({
        url: `/pharma/pharmacies`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    update: (data, headers) =>
      request({
        url: `/pharma/pharmacies/${data?.id}`, method: 'put', data: { ...data.body }, headers: { ...headers }
      }),
    create: (data, headers) =>
      request({
        url: `/pharma/pharmacies`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },
  displayable_medicines: {
    get: (data, headers) =>
      request({
        url: `/pharma/displayable_medicines/find/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/pharma/displayable_medicines`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    update: (data, headers) =>
      request({
        url: `/pharma/displayable_medicines/${data?.id}`, method: 'put', data: { ...data.body }, headers: { ...headers }
      }),
    create: (data, headers) =>
      request({
        url: `/pharma/displayable_medicines`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    delete: (data, headers) =>
      request({
        url: `/pharma/displayable_medicines/${data?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },

  displayable_distributor_medicines: {
    get: (data, headers) =>
      request({
        url: `/pharma/displayable_distributor_medicines/find/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/pharma/displayable_distributor_medicines`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    update: (data, headers) =>
      request({
        url: `/pharma/displayable_distributor_medicines/${data?.id}`, method: 'put', data: { ...data.body }, headers: { ...headers }
      }),
    create: (data, headers) =>
      request({
        url: `/pharma/displayable_distributor_medicines`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    delete: (data, headers) =>
      request({
        url: `/pharma/displayable_distributor_medicines/${data?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },

  patients: {
    add: (data, headers) =>
      request({
        url: `/doctor/internal_patients`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    edit: (data, headers) =>
      request({
        url: `/doctor/internal_patients/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    delete: (data, headers) =>
      request({
        url: `/doctor/internal_patients/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/doctor/internal_patients`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getOne: (data, headers) =>
      request({
        url: `/doctor/internal_patients/${data?.params?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  pos: {
    getreplacment: (data, headers) => {
      return request({
        url: `/pharma/all_pharma_items/replacement/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      })
    },
    getAllreplacment: (data, headers) => {
      return request({
        url: `/pharma/item_cards/replacement/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      })
    },
    getAllItems: (data, headers) => {
      return request({
        url: `/pharma/existing-items`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      })
    },
    sell: (data, headers) =>
      request({
        url: `/pharma/accountant/receipts`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    getOrders: (data, headers) => {
      return request({
        url: `/pharma/accountant/receipts`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      })
    }
  },
  users: {
    getAll: (data, headers) =>
      request({
        url: `/pharma/users`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    addUser: (data, headers) =>
      request({
        url: `/pharma/users`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    updateUser: (data, headers) =>
      request({
        url: `/pharma/users/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    deleteUser: (data, headers) =>
      request({
        url: `/pharma/users/${data?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },
  accountingTransaction: {
    getAll: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-transactions`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getTotals: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-transactions/get-totals`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    addSimpleTran: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-transactions`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),

    openget: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-transactions/1`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    opengetTotals: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-transactions/get-totals/1`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    openadd: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-transactions/opening`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),

    addComplexTrans: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-transactions-composition`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
  },
  unionBills: {
    add: (data, headers) =>
      request({
        url: `/pharma/accountant/unions-bills`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/pharma/accountant/unions-bills`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  bill: {
    purchases: (data, headers) =>
      request({
        url: `/pharma/accountant/bills/purchases-bill`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    add: (data, headers) =>
      request({
        url: `/pharma/accountant/bills`, method: 'post', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    edit: (data, headers) =>
      request({
        url: `/pharma/accountant/bills/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/pharma/accountant/bills`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getLastNumber: (data, headers) =>
      request({
        url: `/pharma/accountant/bills/last/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getTotals: (data, headers) =>
      request({
        url: `/pharma/accountant/bills/get-totals`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getWarehouses: (data, headers) =>
      request({
        url: `/pharma/pharmacy_warehouses`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  orderDist: {
    get: (data, headers) =>
      request({
        url: `/pharma/distributor/pharma_orders`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getDriverSalesman: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen/pharma-order`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    Accept: (data, headers) =>
      request({
        url: `/pharma/distributor/pharma_orders/accept/${data?.id}`, method: 'put', params: { ...data?.params }, headers: { ...headers }
      }),
    Cancel: (data, headers) =>
      request({
        url: `/pharma/distributor/pharma_orders/cancel/${data?.id}`, method: 'put', headers: { ...headers }
      }),
    AssignOrder: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen/assign-order`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },
  orderDistDoctor: {
    get: (data, headers) =>
      request({
        url: `/pharma/distributor/doctor_orders`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    Accept: (data, headers) =>
      request({
        url: `/pharma/distributor/doctor_orders/accept/${data?.id}`, method: 'put', headers: { ...headers }
      }),
    Cancel: (data, headers) =>
      request({
        url: `/pharma/distributor/doctor_orders/cancel/${data?.id}`, method: 'put', headers: { ...headers }
      }),
  },
  orderDistDoctor: {
    get: (data, headers) =>
      request({
        url: `/pharma/distributor/doctor_orders`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    Accept: (data, headers) =>
      request({
        url: `/pharma/distributor/doctor_orders/accept/${data?.id}`, method: 'put', headers: { ...headers }
      }),
    Cancel: (data, headers) =>
      request({
        url: `/pharma/distributor/doctor_orders/cancel/${data?.id}`, method: 'put', headers: { ...headers }
      }),
  },
  distributor: {
    getSalesmen: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    createSalesman: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    updateSalesman: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    assignOrder: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen/assign-order`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    completeOrder: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen/pharma-order/complete`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getDistributionAreas: (data, headers) =>
      request({
        url: `/pharma/distributor/regions`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    createDistributionArea: (data, headers) =>
      request({
        url: `/pharma/distributor/regions`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    updateDistributionArea: (data, headers) =>
      request({
        url: `/pharma/distributor/regions/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getSalesmenRegions: (data, headers) =>
      request({
        url: `/pharma/distributor/salesman-regions`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    createSalesmanRegion: (data, headers) =>
      request({
        url: `/pharma/distributor/salesman-regions`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    updateSalesmanRegion: (data, headers) =>
      request({
        url: `/pharma/distributor/salesman-regions/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getSalesmanAssignedOrders: (data, headers) =>
      request({
        url: `/pharma/distributor/distributor-salesmen/assigned-orders`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  order: {
    getMyOrders: (data, headers) =>
      request({
        url: `/pharma/pharma_orders`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    CancelMyOrders: (data, headers) =>
      request({
        url: `/pharma/pharma_orders/cancel/${data?.id}`, method: 'put', headers: { ...headers }
      }),
    get: (data, headers) =>
      request({
        url: `/pharma/orders`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getPaymentMethod: (data, headers) =>
      request({
        url: `/enums/PaymentMethod`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    Accept: (data, headers) =>
      request({
        url: `/pharma/orders/accept/${data?.id}`, method: 'put', headers: { ...headers }
      }),
    Cancel: (data, headers) =>
      request({
        url: `/pharma/orders/cancel/${data?.id}`, method: 'put', headers: { ...headers }
      }),
    getDistributors: (data, headers) =>
      request({
        url: `/pharma/distributors`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getDistributorsItems: (data, headers) =>
      request({
        url: `/pharma/medicines/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    checkout: (data, headers) =>
      request({
        url: `/pharma/pharma_orders/checkout`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    pay: (data, headers) =>
      request({
        url: `/pharma/pharma_orders`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },
  account: {
    getMaterialSelection: (data, headers) =>
      request({
        url: `/pharma/item_cards`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    fiscalYearRotation: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-year-rotation`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    FinalAccounts: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-reports/closing-accounts`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    TrialBalance: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-reports/trial-balance`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    profitReport: (data, headers) =>
      request({
        url: `/pharma/accountant/accounting-reports/profit-report`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    addOpeningMerchandise: (data, headers) =>
      request({
        url: `/pharma/accountant/opening-merchandise`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    OpeningMerchandise: (data, headers) =>
      request({
        url: `/pharma/accountant/opening-merchandise`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    MaterialInventory: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/existing-items`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    addMaterialInventory: (data, headers) =>
      request({
        url: `/pharma/accountant/update-existing-items`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    ItemsTransactions: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/items-transactions`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    ItemsTransactionsTotal: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/total-items-transactions`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    ClosingExpireDateItem: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/closing-expire-date-item`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    TotalAccountStatement: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/aggregated-account/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    TotalAccountStatementTotal: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/total-detailed-account/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    addDetailedAccountStatementTotal: (data, headers) =>
      request({
        url: `/pharma/accountant/accounts/matching`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    DetailedAccountStatement: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/detailed-account/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    DetailedAccountStatementTotal: (data, headers) =>
      request({
        url: `/pharma/accountant/reports/total-detailed-account/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    deleterequiredMaterials: (data, headers) =>
      request({
        url: `/pharma/accountant/ordered_items/${data?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
    addrequiredMaterials: (data, headers) =>
      request({
        url: `/pharma/accountant/ordered_items`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getrequiredMaterials: (data, headers) =>
      request({
        url: `/pharma/accountant/ordered_items`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getCompanies: (data, headers) =>
      request({
        url: `/pharma/accountant/accounts/by-number?parent_account_number=${data?.params?.parent_account_number}&only_children=true`, method: 'get', params: { ...data?.params }, headers: { ...headers }
        // url: `/pharma/accountant/unions-bills/get-accounts`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAllCompanies: (data, headers) =>
      request({
        url: `/pharma/constants/companies`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    getAllsupplier: (data, headers) =>
      request({
        url: `/pharma/constants/supplier`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    bill_type_id: (data, headers) =>
      request({
        url: `/enums/bill-type`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getSuppliers: (data, headers) =>
      request({
        url: `/pharma/accountant/suppliers`, method: 'get', params: { ...data?.params }, headers: { ...headers }, /* isCancelToken: true */
      }),
    addSuppliers: (data, headers) =>
      request({
        url: `/pharma/accountant/suppliers`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    editSuppliers: (data, headers) =>
      request({
        url: `/pharma/accountant/suppliers/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    deleteSuppliers: (data, headers) =>
      request({
        url: `/pharma/accountant/suppliers/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),


    getCustomer: (data, headers) =>
      request({
        url: `/pharma/accountant/customers`, method: 'get', params: { ...data?.params }, headers: { ...headers }, /* isCancelToken: true */
      }),
    addCustomer: (data, headers) =>
      request({
        url: `/pharma/accountant/customers`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    editCustomer: (data, headers) =>
      request({
        url: `/pharma/accountant/customers/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    deleteCustomer: (data, headers) =>
      request({
        url: `/pharma/accountant/customers/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),

    getTree: (data, headers) =>
      request({
        url: `/pharma/accountant/accounts`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    addTree: (data, headers) =>
      request({
        url: `/pharma/accountant/accounts`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    editTree: (data, headers) =>
      request({
        url: `/pharma/accountant/accounts/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    deleteTree: (data, headers) =>
      request({
        url: `/pharma/accountant/accounts/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data?.body }, headers: { ...headers }
      }),
  },
  lab: {
    addLab: (data, headers) =>
      request({
        url: `/doctor/laboratories`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },
  reffer: {
    addReffer: (data, headers) =>
      request({
        url: `/doctor/referrals`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },
  doctors: {
    deleteAppointments: (data, headers) =>
      request({
        url: `/doctor/appointments/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    DeletewaitingAppointment: (data, headers) =>
      request({
        url: `/doctor/waiting-appointments/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    addGroups: (data, headers) =>
      request({
        url: `/doctor/groups`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    editGroups: (data, headers) =>
      request({
        url: `/doctor/groups/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    add: (data, headers) =>
      request({
        url: `/doctor/doctors`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    edit: (data, headers) =>
      request({
        url: `/doctor/doctors/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    editwaitingAppointment: (data, headers) =>
      request({
        url: `/doctor/waiting-appointments/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    delete: (data, headers) =>
      request({
        url: `/doctor/doctors/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/doctor/doctors`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getOne: (data, headers) =>
      request({
        url: `/doctor/doctors/${data?.params?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getWaitingAppointments: (data, headers) =>
      request({
        url: `/doctor/waiting-appointments`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    scheduling: (data, headers) =>
      request({
        url: `/doctor/appointments/generate/`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    appointment: (data, headers) =>
      request({
        url: `/doctor/appointments/`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    book: (data, headers) =>
      request({
        url: `/doctor/appointments/book`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    addwaitingAppointment: (data, headers) =>
      request({
        url: `/doctor/waiting-appointments`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },
  sessions: {
    getTeeth: (data, headers) =>
      request({
        url: `/doctor/teeth/${data?.params?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAllNote: (data, headers) =>
      request({
        url: `/doctor/sessions/all-notes/${data?.params?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    editTeeth: (data, headers) =>
      request({
        url: `/doctor/teeth_notes`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getSession: (data, headers) =>
      request({
        url: `/doctor/sessions/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getImagesSession: (data, headers) =>
      request({
        url: `/doctor/session-images/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAllImages: (data, headers) =>
      request({
        url: `/doctor/session-images/get-all-by-patient/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    addImage: (data, headers) =>
      request({
        url: `/doctor/session-images`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    add: (data, headers) =>
      request({
        url: `/doctor/sessions`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    edit: (data, headers) =>
      request({
        url: `/doctor/sessions/${data?.params?.id}`, method: 'put', data: { ...data.body }, params: { ...data?.params }, headers: { ...headers }
      }),
  },
  operations: {
    deleteOperationStatic: (data, headers) =>
      request({
        url: `/doctor/operations/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    deleteDiagnosticsStatic: (data, headers) =>
      request({
        url: `/doctor/operations/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    delete: (data, headers) =>
      request({
        url: `/doctor/sessions-operations/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    deleteDiagnostics: (data, headers) =>
      request({
        url: `/doctor/sessions-diagnostics/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    deleteDiagnostics: (data, headers) =>
      request({
        url: `/doctor/sessions-diagnostics/${data?.params?.id}`, method: 'delete', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getLab: (data, headers) =>
      request({
        url: `/doctor/laboratories`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getReferrals: (data, headers) =>
      request({
        url: `/doctor/referrals`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getType: (data, headers) =>
      request({
        url: `/enums/operation-type`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getCorrelation: (data, headers) =>
      request({
        url: `/enums/operation-correlation`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/doctor/sessions/find/${data.params.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAllWorks: (data, headers) =>
      request({
        url: `/doctor/sessions-operations/by-patient/${data.params.id}`, method: 'get', headers: { ...headers }
      }),
    operationsStatic: (data, headers) =>
      request({
        url: `/doctor/operations`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    diagnosticsStatic: (data, headers) =>
      request({
        url: `/doctor/diagnostics`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    editOperationsStatic: (data, headers) =>
      request({
        url: `/doctor/operations/${data?.params?.id}`, method: 'put', data: { ...data.body }, params: { ...data?.params }, headers: { ...headers }
      }),
    editDiagnosticsStatic: (data, headers) =>
      request({
        url: `/doctor/diagnostics/${data?.params?.id}`, method: 'put', data: { ...data.body }, params: { ...data?.params }, headers: { ...headers }
      }),
    add: (data, headers) =>
      request({
        url: `/doctor/operations`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    addDiagnostics: (data, headers) =>
      request({
        url: `/doctor/diagnostics`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    createOperation: (data, headers) =>
      request({
        url: `/doctor/sessions-operations`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    createDiagnostics: (data, headers) =>
      request({
        url: `/doctor/sessions-diagnostics`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    edit: (data, headers) =>
      request({
        url: `/doctor/sessions-operations/done/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    editDiagnostics: (data, headers) =>
      request({
        url: `/doctor/sessions-diagnostics/${data?.params?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
  },

  products: {
    add: (data, headers) =>
      request({
        url: `/pharma/item_cards`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    exploreAllMedicines: (data, headers) =>
      request({
        url: `/pharma/item_cards`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAll: (data, headers) =>
      request({
        url: `/pharma/item_cards`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAllPharma: (data, headers) =>
      request({
        url: `/pharma/all_pharma_items`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    addAllPharma: (data, headers) =>
      request({
        url: `/pharma/all_pharma_items`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getPharma: (data, headers) =>
      request({
        url: `/pharma/all_pharma_items/find/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getPharmaItemCard: (data, headers) =>
      request({
        url: `/pharma/item_cards/find/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getPrivateProducts: (data, headers) =>
      request({
        url: `/pharma/pharma_products`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    deletePrivateProduct: (data, headers) =>
      request({
        url: `/pharma/pharma_products/${data.id}`, method: 'delete', headers: { ...headers }
      }),
    deleteAllOpen: (data, headers) =>
      request({
        url: `/pharma/accountant/opening-merchandise`, method: 'delete', headers: { ...headers }
      }),
    deleteOpen: (data, headers) =>
      request({
        url: `/pharma/accountant/opening-merchandise/${data.id}`, method: 'delete', headers: { ...headers }
      }),
    addPrivateProducts: (data, headers) =>
      request({
        url: `/pharma/pharma_products`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    editPrivateProducts: (data, headers) =>
      request({
        url: `/pharma/pharma_products/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    getPrivateProduct: (data, headers) =>
      request({
        url: `/pharma/pharma_products/find/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  static: {
    pharmaceutical_classification: (data, headers) =>
      request({
        url: `/pharma/constants/classifications`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    currency: (data, headers) =>
      request({
        url: `/pharma/user-currencies`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    editCurrency: (data, headers) =>
      request({
        url: `/pharma/user-currencies/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    addCurrency: (data, headers) =>
      request({
        url: `/pharma/user-currencies`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    repository: (data, headers) =>
      request({
        url: `/pharma/pharmacy_warehouses`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    editrepository: (data, headers) =>
      request({
        url: `/pharma/pharmacy_warehouses/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    addrepository: (data, headers) =>
      request({
        url: `/pharma/pharmacy_warehouses`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    pharmaceuticalCompanies: (data, headers) =>
      request({
        url: `/pharma/constants/companies`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getAllCompanies: (data, headers) =>
      request({
        url: `/pharma/constants/companies`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    account_type_id: (data, headers) =>
      request({
        url: `/enums/AccountType`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    closing_account_id: (data, headers) =>
      request({
        url: `/enums/ClosingAccount`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    currency_id: (data, headers) =>
      request({
        url: `/enums/Currency`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    type_materials: (data, headers) =>
      request({
        url: `/pharma/constants/type-material`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    parent_Account: (data, headers) =>
      request({
        url: `/pharma/accountant/accounts/main`, method: 'get', params: { ...data?.params, per_page: 100000000000000 }, headers: { ...headers }
      }),
    shape_id: (data, headers) =>
      request({
        url: `/pharma/constants/shapes`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    caliber_id: (data, headers) =>
      request({
        url: `/pharma/constants/calibers`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    composition_id: (data, headers) =>
      request({
        url: `/pharma/constants/composition`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    general_group_id: (data, headers) =>
      request({
        url: `/pharma/constants/general-group`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    pharmaceutical_company_id: (data, headers) =>
      request({
        url: `/pharma/constants/companies`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    partial_unit_id: (data, headers) =>
      request({
        url: `/pharma/constants/partial-unit`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    groups: (data, headers) =>
      request({
        url: `/doctor/groups`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    gender: (data, headers) =>
      request({
        url: `/enums/gender`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    teethColor: (data, headers) =>
      request({
        url: `/enums/tooth-color`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    teethStatus: (data, headers) =>
      request({
        url: `/enums/tooth-status`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    jobs: (data, headers) =>
      request({
        url: `/jobs`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    regions: (data, headers) => {
      const id = data?.id || data?.params?.id;
      const url = id ? `/regions/${id}` : `/regions`;
      return request({
        url: url, method: 'get', params: { ...data?.params }, headers: { ...headers }
      });
    },

    cities: (data, headers) =>
      request({
        url: `/states/${data.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    states: (data, headers) =>
      request({
        url: `/states/${data.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    countries: (data, headers) =>
      request({
        url: `/countries`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    insurance: (data, headers) =>
      request({
        url: `/insurance-companies`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  user: {
    login: (data, headers) =>
      request({
        url: `/auth/pharma/login`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    register: (data, headers) =>
      request({
        url: `/auth/pharma/register`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    verify: (data, headers) =>
      request({
        url: `/auth/pharma/verify-otp`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    resend: (data, headers) =>
      request({
        url: `/auth/pharma/send-otp`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    resterPass: (data, headers) =>
      request({
        url: `/auth/pharma/verify-otp-and-reset-password`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    me: (data, headers) =>
      request({
        url: `/auth/pharma/me`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    roles: (data, headers) =>
      request({
        url: `/pharma/roles`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),

    addroles: (data, headers) =>
      request({
        url: `/pharma/roles`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    editroles: (data, headers) =>
      request({
        url: `/pharma/roles/${data.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),

    permissions: (data, headers) =>
      request({
        url: `/pharma/permissions`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  test: {
    enums: (data, headers) =>
      request({
        url: `/enums/response-code`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
  },
  BeautyCenter: {
    getAll: (data, headers) =>
      request({
        url: `/admin/beauty-center`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    getById: (data, headers) =>
      request({
        url: `/admin/beauty-center/${data?.id}`, method: 'get', params: { ...data?.params }, headers: { ...headers }
      }),
    add: (data, headers) =>
      request({
        url: `/admin/beauty-center`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    delete: (data, headers) =>
      request({
        url: `/admin/beauty-center/${data.id}`, method: 'delete', headers: { ...headers }
      }),
    edit: (data, headers) =>
      request({
        url: `/admin/beauty-center/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    addAvatar: (data, headers) =>
      request({
        url: `/admin/beauty-center-images/${data?.id}`, method: 'post', params: { ...data?.params }, data: data.body, headers: { ...headers, 'content-type': 'multipart/form-data', }
      }),
    addService: (data, headers) =>
      request({
        url: `/admin/beauty-center-services`, method: 'post', params: { ...data?.params }, data: data.body, headers: { ...headers, 'content-type': 'multipart/form-data', }
      }),
    editService: (data, headers) =>
      request({
        url: `/admin/beauty-center-services/${data?.id}?_method=PUT`, method: 'post', params: { ...data?.params }, data: data.body, headers: { ...headers, 'content-type': 'multipart/form-data', }
      }),
    deleteService: (data, headers) =>
      request({
        url: `/admin/beauty-center-services/${data.id}`, method: 'delete', headers: { ...headers }
      }),
    addBranche: (data, headers) =>
      request({
        url: `/admin/beauty-center-branches`, method: 'post', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers, 'content-type': 'multipart/form-data', }
      }),
    editBranche: (data, headers) =>
      request({
        url: `/admin/beauty-center-branches/${data?.id}`, method: 'put', params: { ...data?.params }, data: { ...data.body }, headers: { ...headers }
      }),
    deleteBranche: (data, headers) =>
      request({
        url: `/admin/beauty-center-branches/${data.id}`, method: 'delete', headers: { ...headers }
      }),
  },
};

export default endpoints;
